export const CREATE_EMPTY_CART_MUTATION = `
mutation {
  createEmptyCart
}
`;
